Apt.fn.make('price', {
	/**
	 * Initialize module
	 *
	 * @param {String} territory
	 */
	init(territory) {
		const priv = this.$private;

		priv.location = 'united-states';

		priv.asc = true;
		priv.order = 'name';

		if (territory) {
			priv.location = territory;
			priv.type = 'territory';
		}

		if (priv.table) {
			priv.select(
				$('input', '$priceTable').filter(`[value="${priv.location}"]`)
			);

			return;
		}

		priv.render();
		priv.update();
		priv.bind();

		if (! territory) {
			priv.meta = Apt.fn.meta()
				.init();
		}
	},

	/**
	 * Evaluate preload logic
	 */
	preload() {
		if (! this.$private.table) {
			return;
		}

		const pending = $.history.pending();

		if (! pending || ! pending.action || ! pending.run) {
			return;
		}

		pending.action = false;
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('price', this.$private, [
			'index',
			'meta',
			'table',
			'tabs'
		]);
	}
}, {
	_construct() {
		const scope = this;

		scope.price = [
			5000,
			10000,
			25000,
			50000,
			75000,
			100000,
			250000,
			500000,
			750000,
			1000000,
			2500000,
			5000000,
			10000000,
			null
		];

		scope.sizes = [
			null,
			5,
			10,
			25,
			50,
			75,
			100,
			250,
			500,
			750,
			1000,
			2500,
			5000,
			10000
		];
	},

	/**
	 * Render locations
	 */
	render() {
		const scope = this;

		scope.table = $.app.make('locations', {
			view: 'price.locations',
			target: '$priceTable',
			model: {
				active: scope.location,
				asc: true,
				order: 'name',
				results: []
			}
		});
	},

	/**
	 * Update price data
	 */
	update() {
		const scope = this;
		const $locations = $$('priceLocations');
		const criteria = scope.getData();

		$locations.addClass('g-loading');

		if (scope.type === 'territory') {
			criteria.location = scope.location;
		}

		LS.api.get('price', {
			data: criteria,
			success: data => {
				const merge = {
					group: scope.getGroup(),
					parent: null
				};

				merge.results = data.results.map(location => scope.transform(location));

				merge.location = scope.transform(data.location, true);

				if (data.parent) {
					merge.parent = scope.transform(data.parent, true);
				}

				scope.arrange(merge.results);

				scope.table.$merge(merge);
			},
			complete: () => $locations.removeClass('g-loading')
		});

		scope.refresh();
	},

	/**
	 * Transform location
	 *
	 * @param {Object} location
	 * @param {Boolean} [ancestor=false]
	 * @returns {Object}
	 */
	transform(location, ancestor) {
		location.id = location.type + '-' + location.id;

		if (! ancestor && location.type === 'territory') {
			location.path = '/price/' + location.slug;
		}

		location.totalRaw = location.total || 0;
		location.avgSizeRaw = location.size ?
			location.size / location.total : null;
		location.avgPriceRaw = location.price ?
			location.price / location.total : null;
		location.sizeRaw = location.size;
		location.ppaRaw = location.price && location.size ?
			location.price / location.size : null;
		location.sizeRaw = location.size;

		location.total = location.total ?
			LS.util.formatNumber(location.total) : 0;
		location.avgPrice = location.avgPriceRaw ?
			LS.util.formatCurrency(location.avgPriceRaw) : '—';
		location.ppa = location.ppaRaw ?
			LS.util.formatCurrency(location.ppaRaw) : '—';
		location.size = location.size ?
			LS.util.formatNumber(location.size) : '—';
		location.avgSize = location.avgSizeRaw ?
			LS.util.formatNumber(location.avgSizeRaw, location.avgSizeRaw < 10 ? 1 : 0, true) + ' ac' : '—';

		return location;
	},

	/**
	 * Refresh listing data
	 *
	 * @param {Boolean} [scroll=false]
	 */
	refresh(scroll) {
		const scope = this;
		const criteria = scope.getData();

		if (scope.index) {
			criteria.page = 1;

			scope.index.filter(criteria);

			return;
		}

		const $target = $$('priceListings');

		let events;

		scope.index = Apt.fn.index().init({
			app: 'price',
			view: 'price.results',
			resource: 'listings',
			target: $target,
			event: false,
			scrollTop: results => ! (! scroll && results.current_page === 1),
			paginate: true,
			model: {
				label: 'property',
				loading: true,
				standalone: true
			},
			static: true,
			filters: criteria,
			params: {
				limit: 6,
				format: 'sale',
				user: LS.user.get('id')
			},
			translate: filters => {
				filters.sort = scope.sort || '-promoted';

				if (criteria.location === 'united-states') {
					delete filters.location;
				}
			},
			transform: Apt.properties.transform,
			updated: (data, init) => {
				const results = data.results;

				if (! init && events) {
					events.update();
				}

				Object.values(results).forEach(item => {
					LS.analytics.track({
						action: 'preview',
						target: 'listing',
						id: item.id,
						category: 'entry',
						segment: 'price'
					}, {
						key: item.context.key,
						source: item.context.source,
						send: false
					});
				});

				LS.analytics.send();
			},
			unload: () => {
				if (events) {
					events.unload();
				}
			},
			destroy: () => {
				if (events) {
					events.$destroy();
				}
			}
		}, () => {
			events = Apt.fn['properties.events']()
				.init({
					app: 'price',
					delegate: $target
				});
		});
	},

	/**
	 * Bind events
	 */
	bind() {
		const scope = this;
		const $inputs = $$('pricePrice, priceSize, priceType, priceStructure');
		const $locations = $$('priceLocations');
		const $table = $$('priceTable');
		const filters = {};

		$.events.on({
			'$pricePrice': {
				input: (e, el) => {
					let val = scope.getPrice(el.value);

					if (! val) {
						val = 'Any price';

						delete filters.price;
					} else {
						filters.price = val;
						val = LS.util.formatCurrency(val);
					}

					el.nextElementSibling.textContent = val;
				}
			},
			'$priceSize': {
				input: (e, el) => {
					let val = scope.getSize(el.value);

					if (! val) {
						val = 'Any size';

						delete filters.size;
					} else {
						filters.size = val;
						val = LS.util.formatNumber(val) + ' acres';
					}

					el.nextElementSibling.textContent = val;
				}
			}
		}, {
			namespace: 'price'
		});

		scope.tabs = Apt.fn.tab()
			.init('$priceSort', (id, init) => {
				scope.sort = id;

				if (! init) {
					scope.refresh();
				}
			});

		$inputs.on('change', () => $locations[0].classList.add('g-loading'), {
			namespace: 'price'
		});

		$inputs.on('change', () => {
			scope.update();
		}, {
			namespace: 'price',
			debounce: 500
		});

		$.events.on('input', 'change', (e, el) => {
			scope.select(el);
		}, {
			namespace: 'price',
			delegate: $table,
			debounce: 500
		});

		$.events.on('a', 'click', (e, el) => {
			el.target = '_blank';
		}, {
			namespace: 'price',
			delegate: '$priceListings'
		});

		$.events.on({
			'thead th': {
				click: (e, el) => {
					const results = scope.table.$get('results');
					const order = el.dataset.key;

					let asc = true;

					if (scope.order === order) {
						asc = ! scope.asc;
					}

					scope.asc = asc;
					scope.order = order;

					scope.arrange(results);

					scope.table.$merge({
						asc: scope.asc,
						order: scope.order,
						results: results
					});

					$table.scrollTop(0);
				}
			},
			'a': {
				click: e => {
					e.preventDefault();
				}
			}
		}, {
			namespace: 'price',
			delegate: $table
		});
	},

	/**
	 * Make selection
	 *
	 * @param {$} el
	 */
	select(el) {
		const scope = this;
		const type = el.dataset.type;

		scope.table.$set('active', el.value);

		if (type !== 'subterritory') {
			scope.location = el.value;
			scope.type = type;

			$.history.go({
				bypass: true,
				partials: 'title, $priceTitle, $priceMessage',
				force: true,
				path: scope.type === 'country' ?
					'/price' : '/price/' + scope.location,
				run: false,
				scrollTop: false
			});

			$$('priceTable').scrollTop(0);

			scope.update();

			return;
		}

		scope.refresh(true);
	},

	/**
	 * Sort results
	 *
	 * @param {Array} results
	 */
	arrange(results) {
		const scope = this;
		const asc = scope.asc;

		let key = scope.order;

		if (key !== 'name') {
			key += 'Raw';
		}

		results.sort((a, b) => {
			if (key === 'name') {
				return (asc ? a[key] : b[key])
					.localeCompare(asc ? b[key] : a[key], undefined, {
						numeric: true
					});
			}

			if (! a[key]) {
				return 1;
			}

			if (! b[key]) {
				return -1;
			}

			return asc ?
				a[key] - b[key] : b[key] - a[key];
		});
	},

	/**
	 * Get location group
	 *
	 * @returns {String}
	 */
	getGroup() {
		const scope = this;

		let group = 'States';

		if (scope.type === 'territory') {
			group = 'Counties';

			if (scope.location === 'alaska') {
				group = 'Boroughs';
			} else if (scope.location === 'louisiana') {
				group = 'Parishes';
			}
		}

		return group;
	},

	/**
	 * Get input price
	 *
	 * @param {Number} value
	 * @returns {Number}
	 */
	getPrice(value) {
		return this.price[Number(value)];
	},

	/**
	 * Get input size
	 *
	 * @param {Number} value
	 * @returns {Number}
	 */
	getSize(value) {
		return this.sizes[Number(value)];
	},

	/**
	 * Get input data
	 *
	 * @returns {Object}
	 */
	getData() {
		const scope = this;
		const values = $$('priceForm').serialize(true);
		const price = scope.getPrice(values.price);
		const size = scope.getSize(values.size);

		return {
			structure: values.structure,
			type: values.type,
			location: values.location || scope.location,
			price: price ? {
				max: price
			} : '',
			size: size ? {
				min: size
			} : ''
		};
	}
});